import React, { useState } from 'react'
import RsIcon from '../icons/RsIcon'
import axios from 'axios'
import toast from 'react-hot-toast'

function formatAmount(amount, currency = 'CNY') {
  if (currency === 'USD') return `$${Number(amount).toLocaleString()}`
  return `¥${Number(amount).toLocaleString()}`
}

export default function StaticWeChatPayModal({ order, onClose, onSuccess }) {
  const [confirming, setConfirming] = useState(false)
  const [reported, setReported] = useState(false)

  if (!order) return null

  const handleReportPaid = async () => {
    setConfirming(true)
    try {
      await axios.post(`/api/payments/static-qr/${order.orderId}/confirm`)
      setReported(true)
      toast.success('Payment notification submitted')
      onSuccess?.()
    } catch (err) {
      toast.error(err.response?.data?.message || 'Submission failed — please try again later')
    } finally {
      setConfirming(false)
    }
  }

  return (
    <div className="static-wechat-pay-overlay">
      <div className="static-wechat-pay-modal">
        <button type="button" className="static-wechat-pay-close" onClick={onClose} aria-label="Close">
          <RsIcon name="close" size={20} />
        </button>

        {reported ? (
          <div className="static-wechat-pay-success">
            <div className="static-wechat-pay-success-icon">
              <RsIcon name="check" size={36} />
            </div>
            <p className="static-wechat-pay-success-title">Notification received</p>
            <p className="static-wechat-pay-success-sub">
              Our team will verify your WeChat transfer and activate your account manually. This usually takes 1–2 business days.
            </p>
          </div>
        ) : (
          <>
            <div className="static-wechat-pay-qr-wrap">
              <img
                src="/images/wechat-static-qr.png"
                alt="WeChat Pay QR code"
                className="static-wechat-pay-qr"
              />
            </div>

            <div className="static-wechat-pay-amount">
              <span className="static-wechat-pay-amount-label">Amount due</span>
              <span className="static-wechat-pay-amount-value">
                {formatAmount(order.amountYuan, order.currency)}
              </span>
            </div>

            <p className="static-wechat-pay-hint">
              Scan the QR code with WeChat and transfer the exact amount shown. After payment, click below to notify us — an admin will verify and activate your account.
            </p>

            <p className="static-wechat-pay-remind">
              Please include your <strong>company name</strong> and <strong>email address</strong> in the transfer note.
            </p>

            {order.outTradeNo && (
              <p className="static-wechat-pay-order">
                Order No.: <span>{order.outTradeNo}</span>
              </p>
            )}

            <button
              type="button"
              className="static-wechat-pay-confirm-btn"
              onClick={handleReportPaid}
              disabled={confirming}
            >
              {confirming ? 'Submitting…' : 'I have paid — notify admin'}
            </button>
          </>
        )}
      </div>
    </div>
  )
}
